import { cn } from '@/lib/cn';

/**
 * Decorative sonar sweep for the Radar screen. Pure CSS; frozen under
 * `prefers-reduced-motion` (see global.css). Not interactive, always aria-hidden.
 */
export function Sonar({ className, active = true }: { className?: string; active?: boolean }) {
  return (
    <div
      className={cn('pointer-events-none relative aspect-square w-full max-w-xs', className)}
      aria-hidden
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={cn('absolute inset-0 rounded-full border-2 border-u', active && 'sonar-ring')}
          style={{ animationDelay: `${i * 1.1}s` }}
        />
      ))}
      <span className="absolute inset-0 m-auto size-3 rounded-full bg-accent" />
    </div>
  );
}
